module.exports = __webpack_public_path__ + "assets/Angle30.484d97cd1235b7731b84ba03f5e2440c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle30.gmt
// module id = 893
// module chunks = 0